import { createSelector } from 'reselect'

import { getDashboardState } from '../../../duck/selectors'
import { PEOPLE_MANAGER_STORE_ID } from './types'

export const getPeopleManagerState = createSelector(
  getDashboardState,
  (dashboardState) => dashboardState.scenes[PEOPLE_MANAGER_STORE_ID]
)

export const getSearchParams = createSelector(getPeopleManagerState, (peopleManagerState) => ({
  search: peopleManagerState.search,
  limit: peopleManagerState.limit,
  currentPage: peopleManagerState.currentPage,
}))
